import React from 'react'
import { getBEMCls } from '@/utils/classname'
import { useFullscreen } from 'ahooks'
import './user.scss'
import { userStore } from '@/store/user'
import classNames from 'classnames'
import { Popover, Modal } from 'antd'
import { $post } from '@/api'
import domain from '@/api/config'

const User = () => {
    const ROOT = document.body
    const [isFullscreen, { toggleFull }] = useFullscreen(ROOT)
    const getCls = (el?: string, moder?: string) => getBEMCls('user', el, moder)
    const logout = () => {
        Modal.confirm({
            title: '确定退出登录？',
            onOk: async () => {
                try {
                    await $post({ url: '/staff/stafflogout' })
                } finally {
                    localStorage.removeItem('token')
                    document.cookie.split(';').forEach(cookie => {
                        const name = cookie.split('=')[0].trim()
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
                        if (domain.topLevel) {
                            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain.topLevel}`
                        }
                    })
                    window.location.href = `${domain.passport}/#/login?oa=new_ls`
                }
            },
        })
    }

    return (
        <div className={getCls()}>
            <i
                className={`${getCls('fullscreen')} iconfont ${isFullscreen ? 'icontuichuquanping' : 'iconquanping'}`}
                onClick={toggleFull}
            />

            <Popover
                trigger="click"
                placement="bottomRight"
                content={
                    <div>
                        <button
                            type="button"
                            className={getCls('menu-item')}
                            onClick={() => {
                                window.location.href = `${domain.passport}/#/personalCenter`
                            }}
                        >
                            个人中心
                        </button>
                        <button type="button" className={getCls('menu-item')} onClick={logout}>
                            退出登录
                        </button>
                    </div>
                }
            >
                <button type="button" className={getCls('profile')}>
                    <img
                        src={userStore.userInfo!.avatar}
                        className={classNames(getCls('avatar'), getCls('avatar', userStore.userInfo!.gender + ''))}
                        alt=""
                    />
                    <div className={getCls('info')}>
                        <span className={getCls('info', 'nickname')}>{userStore.userInfo!.nickname}</span>
                        <span className={getCls('info', 'phone')}>
                            {userStore.userInfo!.phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')}
                        </span>
                    </div>
                    <i className={`${getCls('arrow')} iconfont iconrightArrows`} />
                </button>
            </Popover>
        </div>
    )
}

export default User
